import {ActivityJournalChat} from './ActivityJournalChat';
export default ActivityJournalChat;
